const MoneyBack = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.32504 6.43602C7.05214 6.43602 6.02025 7.46791 6.02025 8.74081C6.02025 10.0137 7.05214 11.0456 8.32504 11.0456C9.59794 11.0456 10.6298 10.0137 10.6298 8.74081C10.6298 7.46791 9.59794 6.43602 8.32504 6.43602ZM7.62358 8.74081C7.62358 8.3534 7.93763 8.03935 8.32504 8.03935C8.71244 8.03935 9.02649 8.3534 9.02649 8.74081C9.02649 9.12821 8.71244 9.44227 8.32504 9.44227C7.93763 9.44227 7.62358 9.12821 7.62358 8.74081Z"
        fill="#1D1D1F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.47989 2.09375C2.03714 2.09375 1.67822 2.45267 1.67822 2.89542V11.1626C1.67822 11.3754 1.76281 11.5794 1.91334 11.7298L9.33899 19.1472C9.79945 19.6078 10.4246 19.8672 11.076 19.8672C11.7274 19.8672 12.3521 19.6083 12.8126 19.1474L18.7402 13.2199L18.741 13.2182C19.6938 12.2606 19.6938 10.7141 18.7419 9.7565L11.3139 2.32855C11.1636 2.17821 10.9597 2.09375 10.7471 2.09375H2.47989ZM3.28155 6.29661V10.8303L7.32018 14.8644L3.28155 6.29661ZM3.28155 6.29661L7.32018 14.8644L10.4727 18.0134C10.6325 18.1734 10.8499 18.2638 11.076 18.2638C11.3021 18.2638 11.5188 18.174 11.6786 18.0141L17.6048 12.0878L17.6056 12.087C17.9348 11.755 17.9348 11.2197 17.6056 10.8877L17.6048 10.8869L10.415 3.69708H3.28155V6.29661Z"
        fill="#1D1D1F"
      />
    </svg>
  )
}

export default MoneyBack
